<template>
  <div>
    <div class="oper_box" v-if="tableObj.buttonShow == true">
      <el-button @click="toAdd(0)">
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        新增培训
      </el-button>
      <el-button id="addButtonJm" @click="deleteClick(0)">
        <img src="@/assets/button_imgs/shangchuang.png" alt="" />
        批量删除
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="hos_mian" v-loading="tableObj.loading">
      <el-table
        ref="tabledata"
        :data="tableObj.getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :cell-class-name="stateColor"
        @selection-change="handleSelectionChange"
        @row-click="StepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#EEEEEE',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="50px"
          :reserve-selection="true"
          v-if="!tableObj.selection"
        ></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + (pageIndexs - 1) * eachPageNums + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          :prop="tableObj.qrorop"
          :label="tableObj.qrLabel"
          width="180"
          v-if="tableObj.qrorop && tableObj.qrLabel"
        >
          <template slot-scope="scope" >
            <!-- <i
              style="font-size: 14px"
              class="iconfont icon-ico"
               v-if="tableObj.qrShow == true"
              @click.stop="openqrwindows(scope.row)"
            ></i> -->
            {{ scope.row.Title }}
            <el-tooltip
              placement="right-start"
              effect="darkts"
              v-if="tableObj.tooltipShow == true"
            >
              <div slot="content" class="bubbles_box">
                <p class="mb6">主讲人:{{ scope.row.Lecturer }}</p>
                <p class="mb6">培训地点:{{ scope.row.Address }}</p>
                <p class="mb6">主培训对象:{{ scope.row.Trainee }}</p>
              </div>
              <i class="iconfont icon-gantanhao" style="font-size: 14px"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableObj.formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          align="center"
          :width="tableObj.columnWidth"
        >
          <template slot-scope="scope">
            <div class="operation_">
              <el-button
                v-for="(item, index) in tableObj.buttonArr"
                :key="index"
                type="text"
                size="small"
                :disabled="disabledFun(scope.row, item)"
                @click.stop="getRow(scope.row, scope.$index, item.name, index)"
                :class="
                  buttonGrey(scope.row, item, index, tableObj.buttonArr.length)
                "
              >
                <template v-if="buttonShowClick(scope.row, item) == true">
                  {{ item.name }}
                </template></el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="foot_box">
      <div class="foot_pagetions">
        <p>
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div> -->
    <!-- 二维码弹窗 -->
    <QrPopup
      v-if="tableObj.qrShow == true"
      ref="qrpopup"
      :qrObj="qrObj"
      :title="'考核二维码'"
      :statePopupstatus="statePopupstatus"
    />
  </div>
</template>

<script>
import { hybrid } from "@/mixin/mixin";
import QrPopup from "./QrPopup.vue";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      multipleSelection: [], // 表单选中
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      statePopupstatus: {}, // 当前行的信息
      deleteType: "", // 删除弹窗状态
      userName: "", // 单个删除的名字
      deleteNum: "", // 批量删除的个数
      //   disabledType:false, // 是否禁用
    };
  },
  mixins: [hybrid], // 引入共用方法
  props: {
    pageIndexs: {
      type: Number,
      default: () => {},
    },
    eachPageNums: {
      type: Number,
      default: () => {},
    },
    tableObj: {
      type: Object,
      default: () => {},
    }, //
    qrObj: {
      type: Object, // 二维码弹窗
      default: () => {},
    }, //
    toAdd: {
      type: Function, // 添加方法
      default: () => {
        return Function;
      },
    },
    stateColor: {
      type: Function,
      default: () => {
        // 列表内颜色逻辑
        return Function;
      },
    },
    deleteClick: {
      type: Function,
      default: () => {
        // 删除
        return Function;
      },
    },
    fun1: {
      type: Function,
      default: () => {
        // 操作按钮一
        return Function;
      },
    },
    fun2: {
      type: Function,
      default: () => {
        return Function; // 操作按钮二
      },
    },
    fun3: {
      type: Function,
      default: () => {
        return Function; // 操作按钮三
      },
    },
    fun4: {
      type: Function,
      default: () => {
        return Function; // 操作按钮四
      },
    },
    fun5: {
      type: Function,
      default: () => {
        return Function; // 操作按钮四
      },
    },
    disabledFun: {
      type: Function,
      default: () => {
        return Function; // 是否禁用
      },
    },
    buttonShowClick: {
      type: Function,
      default: () => {
        return Function; // 是否显示
      },
    },
    buttonGrey: {
      type: Function,
      default: () => {
        return Function; // 是否显示
      },
    },
    getDatalist: {
      type: Function,
      default: () => {
        return Function; // 获取列表的方法
      },
    },
  },
  components: {
    QrPopup,
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val; // 批量删除多选状态
      val.forEach((v) => {
        this.multipleSelectionIds.push(v.ID);
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      // console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    getRowKeyOfTarget(row) {
      return row.ID;
    },
    // 二维码弹窗
    openqrwindows(testid) {
      //打开二维码传入试卷ID
      // this.qrdialogVisible = true;
      this.$refs.qrpopup.dialogVisibleObj.qrPopup = true; // 唤起弹窗
      this.statePopupstatus = testid;
      let parmars = {
        value: "1",
        examid: testid.ID,
        paperid: testid.PaperID,
      };
      // this.$refs.qrpopup.config.value = JSON.stringify(parmars);
      this.$refs.qrpopup.config.value = `${process.env.VUE_APP_QR}/checkDetail?examineID=${testid.ID}`;
      //生成图片
      setTimeout(() => {
        const canvasIns = html2canvas(this.$refs.qrpopup.$refs.codeDownLoad, {
          backgroundColor: "#fff",
          useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
          logging: true,
          scale: 2,
        }).then(
          (canvas) => {
            const url = canvas.toDataURL("image/png", 1.0);
            this.$refs.qrpopup.$refs.saveImage.setAttribute("src", url);
          },
          (err) => {}
        );
      }, 500);
    },
    // 是否禁用
    // disabledFun(row) {
    //   console.log(row);
    //   if(row.name == '蔡徐坤'){
    //       return true
    //   }else {
    //       return false
    //   }
    // },
    //获取当前行
    getRow(row, index, name, indexx) {
      this.statePopupstatus = row;
      let obj = {
        row: this.statePopupstatus,
        index: index,
      };
      this.$emit("row", obj);
      switch (indexx) {
        case 0:
          return this.fun1();
        case 1:
          return this.fun2();
        case 2:
          return this.fun3();
        case 3:
          return this.fun4();
        case 4:
          return this.fun5();
      }
      console.log(row, index, name, indexx);
    },
    /*
    tableObj对象传参
     tableObj: {
        buttonShow: true, // 是否有添加按钮
        getData: [], // 列表数据
        formColumns: [], // 表头
        qrLabel: "操作名称", // table二维码label
        qrorop: "name",
        loading: false,
        tooltipShow: false,
        columnWidth: "360", // 操作按钮宽度
        buttonArr: [
          {
            name: "评分管理",
            type: false, // 是否禁用
          },
        ],
      },
    */
  },
  computed: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.hos_table {
  min-height: 560px;
}
.grey {
  color: #c0c4cc;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
// 表格
.hos_mian {
  padding: 0px 24px;
  margin-top: 24px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(11) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      font-weight: 400;
      // color: #0084ea;
      > span {
        padding-right: 8px;
        border-right: 1px solid #0084ea;
      }
      &:nth-child(3) {
        > span {
          border-right: none !important;
        }
      }
    }
  }
}
::v-deep .border_none {
  > span {
    border-right: none !important;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}

.operation_ {
  ::v-deep .el-button--text {
    font-size: 16px;
    font-weight: 400;
    // color: #0084ea;
    > span {
      padding-right: 8px;
      border-right: 1px solid #0084ea;
    }
    // margin-right: 20px;
    // &:nth-child(4) {
    //   > span {
    //     border-right: none !important;
    //   }
    // }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      margin: 0;
      padding: 0;
      flex: 1;
      width: 80px;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-darkts {
  background: #00d254;
  width: 150px;
  color: #ffffff;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
</style>
